import {useTranslation} from "react-i18next";
import {
    BundleStub,
    watchBundleByIdTqo,
    watchLastTransferForBundleTqo,
    watchOrphanedBundlesTqo
} from "../../../rpc/webrpc-client.gen.ts";
import {Box, Button, Sheet, Stack, Typography} from "@mui/joy";
import {ShinwaJobCapsule} from "../../../job/capsule.tsx";
import {VenueCapsule} from "../../../venue/capsule.tsx";
import {createFileRoute} from "@tanstack/react-router";
import {useCallback} from "react";
import {BundleCapsule} from "../../../bundle/capsule.tsx";
import {useMothership, useSchedulePickupMutation} from "../../../tq/tqx.tsx";
import {SuspenseDialog} from "../../../components/SuspenseDialog.tsx";
import {useInfallibleQuery} from "../../../util/useInfallibleQuery.tsx";
import {useRefreshableInfallibleQuery} from "../../../util/tqrefresh.tsx";
import {PageBody, PageHeader, PageShell} from "../../../routing/shell.tsx";
import {TopBar} from "../../../components/TopBar.tsx";

// TODO: origin isn't always true. something can get abandoned
// at a waystation

function OrphanedBundle({bundleStub}: { bundleStub: BundleStub }) {
    const {t} = useTranslation();
    const mama = useMothership();
    const bundleTqrv = useInfallibleQuery(watchBundleByIdTqo(mama, {bundleId: bundleStub.id}))
    const lastTransferTqrv
        = useInfallibleQuery(watchLastTransferForBundleTqo(mama, {bundleId: bundleStub.id}));
    const lastTransfer = lastTransferTqrv.data;
    const {mutate: schedulePickup} = useSchedulePickupMutation();

    const bundle = bundleTqrv.data;
    if (!bundle?.job) {
        return <BundleCapsule bundle={bundleStub}/>
    }

    const curVenue = lastTransfer?.offloadVenue ?? bundle.origin.venue;

    return <PageShell>
        <PageHeader><TopBar/></PageHeader>
        <PageBody>
            <Stack direction="row" sx={{width: "100%", alignItems: "center"}}>
                <ShinwaJobCapsule job={bundle.job} sx={{px: 2}}/>
                {(curVenue ? <VenueCapsule venue={curVenue}/> : t("venueUnknown"))}
                <Box sx={{flex: 1}}/>
                <Button sx={{px: 2, py: 1.2}} onClick={() => {
                    schedulePickup({food: {bundleId: bundle.id}});
                }}>
                    {t("scheduleOrphan")}
                </Button>
            </Stack>
        </PageBody>
    </PageShell>;
}

function OrphanedBundlePage() {
    const {t} = useTranslation();
    const mama = useMothership();
    const orphansTqrv
        = useRefreshableInfallibleQuery(watchOrphanedBundlesTqo(mama));
    const {mutate: schedulePickup} = useSchedulePickupMutation();
    const orphans = orphansTqrv.data;
    const scheduleAll = useCallback(() => {
        if (orphans) {
            for (const bundle of orphans) {
                schedulePickup({food: {bundleId: bundle.id}});
            }
        }
    }, [orphans, schedulePickup]);

    if (!orphans) {
        return <SuspenseDialog message="fetching orphans"/>;
    }

    return <Sheet>
        <Stack direction="column" spacing={2} sx={{justifyContent: "center"}}>
            <Typography level="h3">{t("orphanedBundles")}</Typography>

            {orphans.length > 0
                ? <>
                    <Button size="lg" sx={{px: 6, py: 1.6}} onClick={scheduleAll}>
                        {t("scheduleAllOrphans")}
                    </Button>

                    {orphans.map(bundleStub => <OrphanedBundle key={bundleStub.id} bundleStub={bundleStub}/>)}
                </>
                : t("noOrphanedBundles")}
        </Stack>
    </Sheet>
}

export const Route = createFileRoute("/_auth/admin/orphaned-bundle")({
    component: OrphanedBundlePage,
});

